import script from "./RoleDistributionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleDistributionChart.vue?vue&type=script&setup=true&lang=js"

import "./RoleDistributionChart.vue?vue&type=style&index=0&id=1fb3f09f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fb3f09f"]])

export default __exports__